"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _LinkContent = _interopRequireDefault(require("./LinkContent"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var CardNavigationItem =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(CardNavigationItem, _React$Component);

  function CardNavigationItem() {
    (0, _classCallCheck2["default"])(this, CardNavigationItem);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(CardNavigationItem).apply(this, arguments));
  }

  (0, _createClass2["default"])(CardNavigationItem, [{
    key: "getColumnStyle",
    value: function getColumnStyle(type, value) {
      var _this$props = this.props,
          height = _this$props.height,
          rounded = _this$props.rounded;
      var baseStyle = {
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        verticalAlign: 'middle',
        padding: '1em',
        borderRadius: "".concat(rounded ? '8px' : '0')
      };
      return type === 'image' ? _objectSpread({}, baseStyle, {
        backgroundImage: "url('".concat(value, "')")
      }) : _objectSpread({}, baseStyle, {
        backgroundColor: value
      });
    }
  }, {
    key: "renderImageColumn",
    value: function renderImageColumn() {
      var _this$props2 = this.props,
          internal = _this$props2.internal,
          slug = _this$props2.slug,
          as = _this$props2.as,
          gatsbyLink = _this$props2.gatsbyLink,
          background = _this$props2.background,
          type = _this$props2.type,
          gutter = _this$props2.gutter,
          height = _this$props2.height;
      var columnStyle = this.getColumnStyle(type, background);
      var bodyStyle = gutter ? columnStyle : {
        textAlign: 'center',
        verticalAlign: 'middle',
        display: 'flex',
        alignItems: 'center',
        height: height,
        width: '100%'
      };

      var body = _react["default"].createElement("div", {
        style: bodyStyle
      });

      return _react["default"].createElement(_semanticUiReact.Grid.Column, {
        key: slug,
        style: !gutter ? columnStyle : {}
      }, _react["default"].createElement(_LinkContent["default"], {
        internal: internal,
        slug: slug,
        body: body,
        as: as,
        gatsbyLink: gatsbyLink
      }));
    }
  }, {
    key: "renderLabelColumn",
    value: function renderLabelColumn() {
      var _this$props3 = this.props,
          internal = _this$props3.internal,
          slug = _this$props3.slug,
          as = _this$props3.as,
          gatsbyLink = _this$props3.gatsbyLink,
          background = _this$props3.background,
          content = _this$props3.content,
          type = _this$props3.type,
          gutter = _this$props3.gutter,
          height = _this$props3.height;
      var columnStyle = this.getColumnStyle(type, background);
      var bodyStyle = gutter ? columnStyle : {
        textAlign: 'center',
        verticalAlign: 'middle',
        display: 'flex',
        alignItems: 'center',
        height: height,
        width: '100%'
      };
      return _react["default"].createElement(_semanticUiReact.Grid.Column, {
        key: slug,
        style: !gutter ? columnStyle : {}
      }, _react["default"].createElement(_LinkContent["default"], {
        internal: internal,
        slug: slug,
        body: content,
        as: as,
        gatsbyLink: gatsbyLink,
        style: bodyStyle
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var type = this.props.type;
      return type === 'image' ? this.renderImageColumn() : this.renderLabelColumn();
    }
  }]);
  return CardNavigationItem;
}(_react["default"].Component);

exports["default"] = CardNavigationItem;